<template>
  <div class="notfound fCol jCenter aCenter">
    <div class="videoHolder">
      <video autoplay loop muted ref="preview">
        <source src="@/assets/404.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <h1>404</h1>
    <h3>:: صفحه مورد نظر پیدا نشد ::</h3>
    <div class="goRimik fRow jCenter aCenter transition-fast primary"
      @click="goRimik">
      <i class="material-icons-round transition-fast">home</i>
      <label>ورود به {{appName.faName}}</label>
    </div>
  </div>
</template>

<script>
// import DashboardPage from '@/components/DashboardPage.vue';

export default {
  methods: {
    goRimik() {
      this.$router.push('/access');
    },
  },
  mounted() {
    this.$store.commit('setLoadingOff');
    this.$refs.preview.play();
  },
  computed: {
    appName() {
      return this.$store.state.appName;
    },
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.notfound{
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  * {
    outline: none;
  }
  .videoHolder {
    width: 350px;
    height: 280px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 24px 48px 0 rgba($color: #000000, $alpha: 0.0);
    video {
      position: absolute;
      outline: none;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 350px;
    }
  }
  h1 {
    font-size: 130px;
    line-height: 1;
    display: none;
    color: rgba($color: #b6b6b6, $alpha: 1);
    text-shadow: 0 16px 16px rgba($color: #000000, $alpha: 0.05);
  }
  h3 {
    font-size: 20px;
    font-weight: 100;
    margin-top: 24px;
    line-height: 1;
    color: rgba($color: #575757, $alpha: 1);
  }
  .goRimik{
    margin-top: 16px;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 8px 12px 0 rgba($color: #000000, $alpha: 0.10);
    i {
      margin-left: 8px;
      color: white;
    }
    label {
      font-size: 14px;
      font-weight: 300;
      color: white;
    }
  }
  .goRimik:hover {
    box-shadow: 0 12px 12px 0 rgba($color: #000000, $alpha: 0.20);
    i {
      margin-left: 16px;
    }
  }
}
</style>
